import { useContext, useEffect, useState } from "react"
import { useAxios } from "../../hooks/useAxios"
import { ModalLoader } from "../../ui/modals/ModalLoarer"
import ModalAnswerHomework from "./ModalAnswerHomework"
import { ModalHomeworkReport } from "./ModalHomeworkReport"
import { DashboardContext } from "./DashboardContext"
import { useTranslation } from "react-i18next"
import moment from "moment"
import { ModalAnswerKey } from "./ModalAnswerKey"
import { v4 } from "uuid"

export const HomeworkView = () => {
  const api = useAxios()
  const { t } = useTranslation()
  const { student } = useContext(DashboardContext)
  const [processing, setProcessing] = useState(false)
  const [showAnswerKey, setShowAnswerKey] = useState(false)
  const [homeworks, setHomeworks] = useState([])
  const [selectedHomework, setSelectedHomework] = useState()
  const [showReport, setShowReport] = useState(false)
  const get = async () => {
    setProcessing(true)
    try {
      const response = await api.get("homeworks?student_id=" + student?.id)
      setHomeworks(response.data)
    } catch (ex) {
      console.error(ex.message)
    } finally {
      setProcessing(false)
    }
  }
  useEffect(() => {
    if (!student.id) return
    get()
  }, [student])
  return (
    <div>
      <ModalLoader show={processing} />
      <ModalHomeworkReport
        show={showReport}
        homework={selectedHomework}
        close={() => {
          setShowReport(false)
          setSelectedHomework(null)
        }}
      />
      {!showReport && !showAnswerKey && (
        <ModalAnswerHomework
          homework={selectedHomework}
          student={student}
          close={() => setSelectedHomework(null)}
          update={(savedHomeworkAnswers) => {
            const updatedHomework = { ...selectedHomework }
            updatedHomework.homework_answers = savedHomeworkAnswers
            const tmphomeworks = [...homeworks]
            for (let i = 0; i < tmphomeworks.length; ++i) {
              const h = tmphomeworks[i]
              if (h.id === selectedHomework.id) {
                tmphomeworks[i] = updatedHomework
                break
              }
            }
            setHomeworks(tmphomeworks)
          }}
        />
      )}
      <ModalAnswerKey
        show={showAnswerKey}
        homework={selectedHomework}
        close={() => {
          setShowAnswerKey(false)
          setSelectedHomework(null)
        }}
      />
      <div className="card">
        {/* <div className="card-header">{t("Homework")}</div> */}
        <div className="card-body">
          <table className="table table-striped tw-hidden md:tw-block w-100 ">
            <thead>
              <tr>
                <th>{t("homework_title")}</th>
                <th>{t("Course")}</th>
                <th className="tw-hidden md:tw-table-cell">{t("Lecture")}</th>
                <th className="tw-hidden md:tw-table-cell">{t("Created at")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="w-100">
              {homeworks?.map((homework) => (
                <tr key={homework.id} className="w-100">
                  <th className="w-25">{homework.name}</th>
                  <th>{homework.lecture.course.name}</th>
                  <th className="tw-hidden md:tw-table-cell">{homework.lecture.name}</th>
                  <th className="tw-hidden md:tw-table-cell">{moment(homework.created_at).format("DD-MM-Y HH:mm")}</th>
                  <td className="tw-text-right tw-w-1/3 ">
                    <div className="btn-group ">
                      <button
                        disabled={homework.homework_answers.length > 0}
                        onClick={() => setSelectedHomework(homework)}
                        className="btn btn-success btn-sm">
                        {t("Answer")}
                      </button>
                      <button
                        onClick={() => {
                          setShowReport(true)
                          setSelectedHomework(homework)
                        }}
                        disabled={homework.homework_answers.length == 0}
                        className="btn-sm btn btn-primary">
                        {t("Results")}
                      </button>
                      <button
                        onClick={() => {
                          setShowAnswerKey(true)
                          setSelectedHomework(homework)
                        }}
                        disabled={homework.homework_answers.length == 0}
                        className="btn-sm btn btn-warning">
                        {t("answer_key")}
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="md:tw-hidden">
            {homeworks?.map((homework) => (
              <div key={v4()} className="tw-mb-4">
                <h1 className="tw-text-lg tw-fond-bold p-0 m-0">{homework.name}</h1>
                <div className="tw-flex tw-justify-between tw-text-sm">
                  <span>{homework.lecture.course.name}</span>
                  <span>{moment(homework.created_at).format("DD-MM-Y HH:mm")}</span>
                </div>
                <div className="btn-group">
                  <button
                    disabled={homework.homework_answers.length > 0}
                    onClick={() => setSelectedHomework(homework)}
                    className="btn btn-success btn-sm">
                    {t("Answer")}
                  </button>
                  <button
                    onClick={() => {
                      setShowReport(true)
                      setSelectedHomework(homework)
                    }}
                    disabled={homework.homework_answers.length == 0}
                    className="btn-sm btn btn-primary">
                    {t("Results")}
                  </button>
                  <button
                    onClick={() => {
                      setShowAnswerKey(true)
                      setSelectedHomework(homework)
                    }}
                    disabled={homework.homework_answers.length == 0}
                    className="btn-sm btn btn-warning">
                    {t("answer_key")}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
